import Helpers from "@/helpers";

export default {
    state: {
        name:'',
        myRoom: null,
        myRoomId: null,
        myRoomIdAlias: null,
        myRoomAlias: null,
        myRoomCurrentPlayer: null,
        myRoomAdmin: null,
        playerTimeout: 20,
        offlinePlayerTimeout: 3,
        elapsedTime: 0,
        mainRoomObject: null,
        bingoRoomObject: null,
        roomsList: [],
        gameStarted: false,
        showCreateRoomBox: false,
        showjoinRoomBox: false,
        networkError: false,
        retryingConnection: false,
        leaveRoomConfirmModal: false
    },
    mutations: {},
    getters: {
        myCellArray: (state, getters, rootState) => {
            if(!state.myRoom[rootState.player.id])return [];
            return state.myRoom[rootState.player.id].cellArray;
        },
        allStrikedCells: (state, getters, rootState) => {
            let allStrikedCells = [];
            for (var playerId in state.myRoom) {
                allStrikedCells = allStrikedCells.concat(
                    state.myRoom[playerId].strikedCells
                );
            }
            return allStrikedCells;
        },
        isMyturn: (state, getters, rootState) => {
            return (
                state.myRoomCurrentPlayer == rootState.player.id &&
                state.gameStarted
            );
        },
        isIamAdmin: (state, getters, rootState) => {
            return (
                state.myRoomAdmin == rootState.player.id
            );
        },
        playersCount: (state, getters, rootState) => {
            return (Object.keys(state.myRoom).length)
        },
        currentPlayerIndex: (state, getters, rootState) => {
            return (Object.keys(state.myRoom).indexOf(state.myRoomCurrentPlayer)) + 1
        },
        totalPlayers: (state, getters, rootState) => {
            return (Object.keys(state.myRoom)).length
        },
        wonPlayersIds: (state, getters, rootState) => {
            return Object.keys(state.myRoom).filter(function (playerId) {
                return state.myRoom[playerId].isWon;
            });
        },
        gameCompleted: (state, getters, rootState) => {
            return getters.wonPlayersIds.length > 0;
        },
        didIwonTheGame: (state, getters, rootState) => {
            return (getters.wonPlayersIds.indexOf(rootState.player.id) >= 0)
        },
        isFirstGame: (state, getters, rootState) => {
            return (!state.gameStarted && !getters.gameCompleted);
        }, highestScorePlayerIds: (state, getters, rootState) => {
            var highestScore = 0;
            for (var playerId in state.myRoom) {
                let playerScore = state.myRoom[playerId].winCount;
                if (playerScore > highestScore) highestScore = playerScore;
            }
            if (highestScore == 0) return [];
            return Object.keys(state.myRoom).filter((playerId) => {
                return state.myRoom[playerId].winCount == highestScore;
            });
        }, getWonStatusText(state, getters, rootState) {
            let winnerNames = [];
            for (var playerId in state.myRoom) {
                if (state.myRoom[playerId].isWon) {
                    if (playerId != rootState.player.id)
                        winnerNames.push(state.myRoom[playerId].playerName);
                }
            }
            const statusText = Helpers.createStatusText(winnerNames);
            if (getters.didIwonTheGame) {
                return statusText + ' also won !';
            }
            else {
                return statusText + ' won the game!'
            }
        }, isIamNewPlayer(state, getters, rootState) {
            return (getters.gameCompleted && !getters.isFirstGame && !state.myRoom[rootState.player.id].strikedCells.length)
        }, timeLeft(state, getters, rootState) {
            const currentPlayerOnline = state.myRoom[state.myRoomCurrentPlayer].isOnline;
            if (currentPlayerOnline) {
                return parseInt(state.playerTimeout-state.elapsedTime);
            } else {
                return parseInt(state.offlinePlayerTimeout-state.elapsedTime);
            }
        }, timeoutBarPercentage(state, getters, rootState) {
            const currentPlayerOnline = state.myRoom[state.myRoomCurrentPlayer].isOnline;
            if (currentPlayerOnline) {
                return parseInt(100 - (state.elapsedTime / state.playerTimeout) * 100);
            } else {
                return parseInt(100 - (state.elapsedTime / state.offlinePlayerTimeout) * 100);
            }
        }, orderedPlayerIds: (state, getters, rootState) => {
            let playerIds = Object.keys(state.myRoom);
            return Helpers.rotateArray(playerIds, rootState.player.id);
        }, onlinePlayerCount: (state, getters, rootState) => {
            return (Object.keys(state.myRoom).filter(function (playerId) {
                return state.myRoom[playerId].isOnline
            })).length;
        }, isDirectRoomLoad: (state, getters, rootState) => {
            return !rootState.mainRoomLoaded;
        }
    }
};
